// extracted by mini-css-extract-plugin
module.exports = {"userContainer":"user-block_userContainer__Xpz8Y","info":"user-block_info__cix5C","menu":"user-block_menu__Sha2d"};